<template>
    <div>
        <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="dropdown" data-target="#myModal">
            <i class="fa fa-cog"></i>
        </button>
        <div class="dropdown-menu">
            <button
                    id="add_To_SuspectedIPs"
                    @click="addToSuspectedIPs(row.id)"
                    class="dropdown-item"
            >
                {{ $t('security.blackList.addToSuspectedIPs') }}
            </button>
            <button
                    id="add_To_BlackIPs"
                    @click="addToBlackIPs(row.id)"
                    class="dropdown-item"
            >
                {{ $t('security.blackList.addToBlackIPs') }}
            </button>
        </div>
    </div>


</template>

<script>

    import store from '@/store'
    import Vue from 'vue'
    import { mapGetters } from 'vuex'
    import {blackListService} from "@/common/api.service";
    import toastr from "toastr";

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            }
        },
        computed: {
            ...mapGetters('blackList', ['suspected_ips', 'status']),
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-top-left",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            }
        },

        methods: {
            addToSuspectedIPs(hashid) {
                blackListService.addToSuspectedIPs(hashid).then(response => {
                    this.toastr.success(response.data.message)
                    store.dispatch('blackList/fetchSuspectedIps')
                    store.dispatch('blackList/fetchBlackIps')
                });
            },
            addToBlackIPs(hashid) {
                blackListService.addToBlackIPs(hashid).then(response => {
                    this.toastr.success(response.data.message)
                    store.dispatch('blackList/fetchBlackIps')
                    store.dispatch('blackList/fetchSuspectedIps')
                });
            },
        },
    })
</script>

<style>

</style>